import { User } from '../../../../types';
import { ConstructGet } from '../../../types/ConstructGet';
import { PaginatedResponse } from '../../../types/PaginatedResponse';
import { USER_BASE_PATH } from '../constants/userBasePath';

export const getUserAssignees = (
  constructGet: ConstructGet,
  searchParams?: Record<string, any>,
): Promise<PaginatedResponse<User[]> | undefined> =>
  constructGet<PaginatedResponse<User[]>>(`${USER_BASE_PATH}/assignees`, {
    params: searchParams,
  });
